<template>
  <div class="container">
    <form class="register-page row">
      <card v-if='confirmed' class="col-sm-6 offset-sm-3 card card card-confirm">
        <div class="confirm-success">
          <i class="el-icon-circle-check-outline"></i>
          <h5>{{$t('Registration confirmed!')}}</h5>
          <p>{{$t('Now you can')}} <router-link to="/auth">{{$t('sign in')}}</router-link> {{$t('to your customer portal')}}</p>
        </div>
      </card>
      <card v-else class="col-sm-6 offset-sm-3 card card card-signup">
          <div class="card-header">
            <h6>{{ $t('We sent you the code to the mail')}}</h6>
            <h6>{{ $t('Enter confirmation code') }}</h6>
          </div>
          <div class="card-body">
              <div>
                  <fg-input
                  name="firstname"
                  type="text"
                  :placeholder="$t('Confirm code')"
                  v-model="code"
                  v-validate="'required'"
                  :error="getError('firstname')"
                  />
              </div>
          </div>
          <div class="card-footer">
            <button type="submit" class="btn btn-primary" @click.prevent="submit()">{{ $t('Confirm') }}</button>
          </div>
      </card>
    </form>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'reg-confirm',
  components: {
  },
  data () {
    return {
      code: '',
      uid: this.$route.params.uid,
      confirmed: false,
      loading: false
    }
  },
  created() {
    if (this.$route.query.hasOwnProperty('id') && this.$route.query.hasOwnProperty('accept_code')) {
      this.code = this.$route.query.accept_code
      this.uid = this.$route.query.id
      this.submit()
    }
  },
  methods: {
    submit () {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.loading = true
            axios.post('registration/confirm', {
              'code': this.code,
              'uid': this.uid
            }).then(promise => {
              this.loading = false
              this.confirmed = true
            }).catch(() => {
              this.loading = false
              this.$notify(
                {
                  message: this.$t('Invalid activation code'),
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                }
              )
            })
          }
        })
    },
    getError (fieldName) {
      return this.$t(this.errors.first(fieldName))
    }
  }
}

</script>

<style scoped>
.confirm-success {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
i {
  font-size: 60px;
  color: #FB7954;
  margin-bottom: 24px;
}
h5 {
  text-align: center;
}
.card-signup,
.card-confirm {
  min-height: 282px;
}
.card-confirm >>> .card-body {
  height: 100% !important;
}

</style>
